export enum Feature {

  CONTACT_VEHICLE = 'CONTACT_VEHICLE',
  CONTACT_VEHICLE_EXTENDED = 'CONTACT_VEHICLE_EXTENDED',
  TRIAL_CONTACT_VEHICLE_EXTENDED = 'TRIAL_CONTACT_VEHICLE_EXTENDED',
  OLD_PART = 'OLD_PART',
  STAHLGRUBER_CATALOG_IMPORT = 'STAHLGRUBER_CATALOG_IMPORT',
  // Email sending basic package - free (activated by default)
  EMAIL_SEND_BASIC = 'EMAIL_SEND_BASIC',
  // Email sending one-time package / Top up emails once - paid
  EMAIL_SEND_ONCE = 'EMAIL_SEND_ONCE',
  // Email sending subscription package small - paid
  EMAIL_SEND_SUBS_SMALL = 'EMAIL_SEND_SUBS_SMALL',
  // Email sending subscription package medium - paid
  EMAIL_SEND_SUBS_MEDIUM = 'EMAIL_SEND_SUBS_MEDIUM',
  // Storage space basic package - free (activated by default)
  STORAGE_BASIC = 'STORAGE_BASIC',
  // Storage space subscription package small - paid
  STORAGE_SMALL = 'STORAGE_SMALL',
  // Storage space subscription package medium - paid
  STORAGE_MEDIUM = 'STORAGE_MEDIUM',
  // Storage space subscription package large - paid
  STORAGE_LARGE = 'STORAGE_LARGE',
  // Wallet top up
  WALLET_TOP_UP_SMALL = 'WALLET_TOP_UP_SMALL',
  WALLET_TOP_UP_MEDIUM = 'WALLET_TOP_UP_MEDIUM',
  WALLET_TOP_UP_LARGE = 'WALLET_TOP_UP_LARGE',
  // Iron-Backup
  IRON_BACKUP = 'IRON_BACKUP',
  // Kontakt Beziehungen / Relationen
  CONTACT_RELATION = 'CONTACT_RELATION',
  TRIAL_CONTACT_RELATION = 'TRIAL_CONTACT_RELATION',
  // Sterbefall / Bestatter
  FUNERAL = 'FUNERAL',
  FUNERAL_EXTENDED = 'FUNERAL_EXTENDED',
  TRIAL_FUNERAL_EXTENDED = 'TRIAL_FUNERAL_EXTENDED',
  // Holzverarbeitung (Holzindustrie / Wood industry)
  WOODWORKING_EXTENDED = 'WOODWORKING_EXTENDED',
  TRIAL_WOODWORKING_EXTENDED = 'TRIAL_WOODWORKING_EXTENDED',
  // Article-Pro
  ARTICLE = 'ARTICLE',
  TRIAL_ARTICLE = 'TRIAL_ARTICLE',
  // Document-Pro - paid
  DOCUMENT = 'DOCUMENT',
  TRIAL_DOCUMENT = 'TRIAL_DOCUMENT',
}
